import { render, staticRenderFns } from "./LoginPrivacy.vue?vue&type=template&id=fdfcc1a2"
import script from "./LoginPrivacy.vue?vue&type=script&lang=js"
export * from "./LoginPrivacy.vue?vue&type=script&lang=js"
import style0 from "./LoginPrivacy.vue?vue&type=style&index=0&id=fdfcc1a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports